"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedEditEventStates = exports.EventState = void 0;
var EventState;
(function (EventState) {
    EventState["WaitingForAssets"] = "Waiting for Assets";
    EventState["ReadyToClip"] = "Ready to Clip";
    EventState["ClippingInProgress"] = "Clipping in Progress";
    EventState["ReviewNeeded"] = "Review Needed";
    EventState["Complete"] = "Complete";
    EventState["Cancelled"] = "Cancelled";
})(EventState = exports.EventState || (exports.EventState = {}));
exports.allowedEditEventStates = [
    EventState.ReadyToClip,
    EventState.ClippingInProgress,
    EventState.ReviewNeeded,
    EventState.Complete,
    EventState.Cancelled,
];
//# sourceMappingURL=event-state.js.map